import * as Turbo from "@hotwired/turbo"
import { Application } from "stimulus"

import * as Sentry from "@sentry/browser"
import { Integrations } from "@sentry/tracing"

Sentry.init({
  dsn: "https://37d21fc959564d7c8624bcbdaf92fc69@o740780.ingest.sentry.io/5786506",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 0.2,
})

import AutocompleteController from "./controllers/autocomplete_controller"
import CheckoutProductController from "./controllers/checkout_product_controller"
import ClockController from "./controllers/clock_controller"
import DropdownController from "./controllers/dropdown_controller"
import GiftCardPaymentController from "./controllers/gift_card_payment_controller"
import NavbarController from "./controllers/navbar_controller"
import TimeslotController from "./controllers/timeslot_controller"
import PaymentController from "./controllers/payment_controller"

// Setup and start Stimulus and its controllers.
const application = Application.start()
application.register("autocomplete", AutocompleteController)
application.register("checkoutProduct", CheckoutProductController)
application.register("clock", ClockController)
application.register("dropdown", DropdownController)
application.register("giftcard-payment", GiftCardPaymentController)
application.register("navbar", NavbarController)
application.register("timeslot", TimeslotController)
application.register("payment", PaymentController)

Turbo.start()
